export const steuerKonstanten = {
    //
    // ######### aus Programmablauf Lohnsteuer 2025 #########
    // https://www.bundesfinanzministerium.de/Content/DE/Downloads/Steuern/Steuerarten/Lohnsteuer/Programmablaufplan/2024-11-22-PAP-2025_anlage.pdf?__blob=publicationFile&v=2

    // Lohnsteuerfreibetrag 2022 oder Grundfreibetrag genannt
    GFB: 12096,

    // Beitragsbemessungsgrenze Kranken- und Pflegeversicherung pro Jahr
    BBGKVPV: 66150,

    // Krankenversicherungssatz im Schnitt in Prozent
    KV_PROZENT: 14.0,

    // Krankenversicherungszusatzbeitrag im Schnitt in Prozent
    KV_ZUSATZ_PROZENT: 2.5,

    // Prozent Beitragsatz für die gesetzliche Pflegeversicherung 3,05%
    // Hälfte davon für Arbeitnehmer spezielle Aufteilung gilt für Sachsen
    PV_SATZ_ALLGEMEIN: 0.036,

    PV_SATZ_AN_SACHEN: 0.023,
    PV_SATZ_AG_SACHSEN: 0.013,
    // Aufschlag Pflegeversicherung für Kinderlose über 23
    // Entfällt ZUSATZ_KINDERLOS: 0.0025,

    // Beitragbemessungsgrenze Lohnsteuer
    // Ost und West gleich seit 2025
    BBG_WEST: 96600,
    BBG_OST: 96600,

    // Rentenversicherungssatz Arbeitnehmer bei 18.7%
    RVSATZAN: 0.093,

    // Teilbetrag Vorsorgepauschale für die Rentenversicherung
    // TBSVORV: 1.00,

    // Grenzwerte für die Steuerklassen V/VI
    W1STKL5: 13785,
    W2STKL5: 34240,
    W3STKL5: 222260,

    // Solidaritätszuschlag Freigrenze für alle Steuerklassen außer 3
    SOLIZFREI: 19950,

    // Entlastungfreibetrag für Alleinerziehende (Steuerklasse 2)
    EFA: 4260,

    // Parameter 2022
    // Arbeitslosenversicherungssatz
    AV_SATZ: 0.012,

    // KINDERFREIBETRAG: Kinderfreibetrag 5460 Euro (2730 Euro je Elternteil) + Freibetrag für Betreuungs- und Erziehungs- oder Ausbildungsbedarf der Kinder in Höhe von 2928 Euro (1464 Euro je Elternteil)
    // für Steuerklasse 1-3 in Steuerklasse 4 nur die Hälfte davon
    KINDERFREIBETRAG_123: 9540,

    // Höchstbetrag der Mindestvorsorgepauschale für die Kranken- und Pflege-Pflichtversicherung in Euro
    VHB_3: 3000,
    VHB_ALLGEMEIN: 1900,

    // Maximal anrechenbare Krankenversicherungsbeiträge für privat Versicherte
    KV_MAX_SK3: 3800,
    KV_MAX_1900: 1900,

    // Lohnsteuergrenze für Soli oberhalb der Milderungszone
    SOLI_MILDERUNGSZONE_MAX: 96820,

    // Werbungskostenpauschale
    ARBEITNEHMER_PAUSCH: 1230,
    // Für Sonderausgaben gilt ein Pauschbetrag von 36 Euro für Singles und 72 Euro für Ehepaare
    SONDERAUSGABEN_PAUSCH: 36,

    // Grenzwerte für die Lohnsteuerberechnung für Steuerklasse < 5 (S. 20)
    // UNTEREPROGRESSIONSZONE immer mit -1 angeben.
    UNTEREPROGRESSIONSZONE: 17443,
    OBEREPROGRESSIONSZONE: 68481,
    OBERGRENZE_PROPORTIONALZONE1: 277826,
    // UNTERGRENZE_PROPORTIONALZONE2 = 274613;

    ALTERS_ENLASTUNG_PROZENT_MAX:
        [
            { jahr: 2005, K: 1, satz: 0.4, max: 1900 },
            { jahr: 2006, K: 2, satz: 0.384, max: 1824 },
            { jahr: 2007, K: 3, satz: 0.368, max: 1748 },
            { jahr: 2008, K: 4, satz: 0.352, max: 1672 },
            { jahr: 2009, K: 5, satz: 0.336, max: 1596 },
            { jahr: 2010, K: 6, satz: 0.32, max: 1520 },
            { jahr: 2011, K: 7, satz: 0.304, max: 1444 },
            { jahr: 2012, K: 8, satz: 0.288, max: 1368 },
            { jahr: 2013, K: 9, satz: 0.272, max: 1292 },
            { jahr: 2014, K: 10, satz: 0.256, max: 1216 },
            { jahr: 2015, K: 11, satz: 0.24, max: 1140 },
            { jahr: 2016, K: 12, satz: 0.224, max: 1064 },
            { jahr: 2017, K: 13, satz: 0.208, max: 988 },
            { jahr: 2018, K: 14, satz: 0.192, max: 912 },
            { jahr: 2019, K: 15, satz: 0.176, max: 836 },
            { jahr: 2020, K: 16, satz: 0.16, max: 760 },
            { jahr: 2021, K: 17, satz: 0.152, max: 722 },
            { jahr: 2022, K: 18, satz: 0.144, max: 684 },
            { jahr: 2023, K: 19, satz: 0.140, max: 665 },
            { jahr: 2024, K: 20, satz: 0.136, max: 646 },
            { jahr: 2025, K: 21, satz: 0.132, max: 627 },
            { jahr: 2026, K: 22, satz: 0.128, max: 608 },
            { jahr: 2027, K: 23, satz: 0.124, max: 589 },
            { jahr: 2028, K: 24, satz: 0.120, max: 570 },
            { jahr: 2029, K: 25, satz: 0.116, max: 551 },
            { jahr: 2030, K: 26, satz: 0.112, max: 532 },
            { jahr: 2031, K: 27, satz: 0.108, max: 513 },
            { jahr: 2032, K: 28, satz: 0.104, max: 494 },
            { jahr: 2033, K: 29, satz: 0.100, max: 475 },
            { jahr: 2034, K: 30, satz: 0.096, max: 456 },
            { jahr: 2035, K: 31, satz: 0.092, max: 437 },
            { jahr: 2036, K: 32, satz: 0.088, max: 418 },
            { jahr: 2037, K: 33, satz: 0.084, max: 399 },
            { jahr: 2038, K: 34, satz: 0.080, max: 380 },
            { jahr: 2039, K: 35, satz: 0.076, max: 361 },
            { jahr: 2040, K: 36, satz: 0.072, max: 342 },
            { jahr: 2041, K: 37, satz: 0.068, max: 323 },
            { jahr: 2042, K: 38, satz: 0.064, max: 304 },
            { jahr: 2043, K: 39, satz: 0.060, max: 285 },
            { jahr: 2044, K: 40, satz: 0.056, max: 266 },
            { jahr: 2045, K: 41, satz: 0.052, max: 247 },
            { jahr: 2046, K: 42, satz: 0.048, max: 228 },
            { jahr: 2047, K: 43, satz: 0.044, max: 209 },
            { jahr: 2048, K: 44, satz: 0.040, max: 190 },
            { jahr: 2049, K: 45, satz: 0.036, max: 171 },
            { jahr: 2050, K: 46, satz: 0.032, max: 152 },
            { jahr: 2051, K: 47, satz: 0.028, max: 133 },
            { jahr: 2052, K: 48, satz: 0.024, max: 114 },
            { jahr: 2053, K: 49, satz: 0.020, max: 95 },
            { jahr: 2054, K: 50, satz: 0.016, max: 76 },
            { jahr: 2055, K: 51, satz: 0.012, max: 57 },
            { jahr: 2056, K: 52, satz: 0.008, max: 38 },
            { jahr: 2057, K: 53, satz: 0.004, max: 19 },
            { jahr: 2058, K: 54, satz: 0.000, max: 0 }
        ],
    KIRCHENSTEUER_TABELLE: {
        "Baden-Württemberg": 0.08,
        Bayern: 0.08,
        "Berlin (West)": 0.09,
        "Berlin (Ost)": 0.09,
        Brandenburg: 0.09,
        Bremen: 0.09,
        Hamburg: 0.09,
        Hessen: 0.09,
        "Mecklenburg-Vorpommern": 0.09,
        Niedersachsen: 0.09,
        "Nordrhein-Westfalen": 0.09,
        "Rheinland-Pfalz": 0.09,
        Saarland: 0.09,
        "Sachsen-Anhalt": 0.09,
        Sachsen: 0.09,
        "Schleswig-Holstein": 0.09,
        Thüringen: 0.09
    }
}

// Für bAV kann maximal 8% der Beitragsbemessungsgrenze West bei der Lohnsteuer geltend gemacht werden
const MAX_BRUTTO_ERRSPARNIS_LOHNSTEUER = 0.08 * steuerKonstanten.BBG_WEST
// Für bAV kann maximal 4% der Beitragsbemessungsgrenze West bei den Sozialversicherungen geltend gemacht werden
const MAX_BRUTTO_ERRSPARNIS_SV = 0.04 * steuerKonstanten.BBG_WEST

export function getMaxAnrechenbahresBAVfLohnsteuer (bAVBeitragProJahr) {
    bAVBeitragProJahr = Object.is(bAVBeitragProJahr, undefined) ? 0 : bAVBeitragProJahr
    if (bAVBeitragProJahr > MAX_BRUTTO_ERRSPARNIS_LOHNSTEUER) {
        bAVBeitragProJahr = MAX_BRUTTO_ERRSPARNIS_LOHNSTEUER
    }
    return bAVBeitragProJahr
}

export function getMaxAnrechenbahresBAVfSozialversicherungen (bAVBeitragProJahr) {
    bAVBeitragProJahr = Object.is(bAVBeitragProJahr, undefined) ? 0 : bAVBeitragProJahr
    if (bAVBeitragProJahr > MAX_BRUTTO_ERRSPARNIS_SV) {
        bAVBeitragProJahr = MAX_BRUTTO_ERRSPARNIS_SV
    }
    return bAVBeitragProJahr
}

// Krankenversicherungssatz Arbeitnehmer auf 5 Nachkommastellen
export function getKVSatzAn () {
    const res = Math.round((steuerKonstanten.KV_PROZENT / 2 / 100 + steuerKonstanten.KV_ZUSATZ_PROZENT / 2 / 100) * 100000)
    return res / 100000
}

// Pflegeversicherungssatz Arbeitnehmer auf 5 Dezimalstellen
export function getPVSatzAn (bundesland, geburtsjahr, anzahlKinder) {
    let PVSATZ = 0
    if (bundesland === "Sachsen") {
        PVSATZ = PVSATZ + steuerKonstanten.PV_SATZ_AN_SACHEN
    } else {
        PVSATZ = PVSATZ + steuerKonstanten.PV_SATZ_ALLGEMEIN / 2
    }
    // Kinderlosenzuschlag bzw. Entlastung bei mehr als einem Kind
    if ((!anzahlKinder || anzahlKinder === 0) && istPerson23oderAelter(geburtsjahr)) {
        PVSATZ = PVSATZ + 0.006
    } else if (anzahlKinder >= 2 && anzahlKinder <= 5) {
        const faktor = anzahlKinder < 5 ? anzahlKinder - 1 : 4
        PVSATZ = PVSATZ - (faktor * 0.0025)
    }
    const PV_SATZ_AN = Math.round(PVSATZ * 100000)
    return PV_SATZ_AN / 100000
}

export function getOstWest (bundesland) {
    return [
        "Brandenburg",
        "Berlin (Ost)",
        "Mecklenburg-Vorpommern",
        "Sachsen",
        "Sachsen-Anhalt",
        "Thüringen"
    ].includes(bundesland)
        ? "osten"
        : "westen"
}

export function getBBGRV (bundesland) {
    const ost_west = getOstWest(bundesland)
    if (ost_west === "osten") {
        return steuerKonstanten.BBG_OST
    }
    return steuerKonstanten.BBG_WEST
}

export function berechneVersicherungsPflichtigesEinkommenRV (jahresBrutto, bundesland, bAVBeitragProJahr) {
    const anrechenbaresBAV = getMaxAnrechenbahresBAVfSozialversicherungen(bAVBeitragProJahr)
    let ZRE4VP = (jahresBrutto - anrechenbaresBAV)
    const BBGRV = getBBGRV(bundesland)
    if (ZRE4VP > BBGRV) {
        ZRE4VP = BBGRV
    }
    return ZRE4VP
}

export function berechneVersicherungsPflichtigesEinkommenKV_PV (jahresBrutto, bAVBeitragProJahr) {
    const anrechenbaresBAV = getMaxAnrechenbahresBAVfSozialversicherungen(bAVBeitragProJahr)
    let ZRE4VP = (jahresBrutto - anrechenbaresBAV)
    if (ZRE4VP > steuerKonstanten.BBGKVPV) {
        ZRE4VP = steuerKonstanten.BBGKVPV
    }
    return ZRE4VP
}

export function getVHB (steuerklasse) {
    let VHB = steuerKonstanten.VHB_ALLGEMEIN
    if (steuerklasse === 3) {
        VHB = steuerKonstanten.VHB_3
    }
    return VHB
}

export function vergleichsberechnungMindestVorsorgePauschale (angenommenesBruttoVP, gesetzlich_versichert, bundesland, geburtsJahr, anzahlKinder, steuerklasse, privat_versichert) {
    let VSP3 = 0
    const versicherungspflichtigesEinkommenKV_PV = berechneVersicherungsPflichtigesEinkommenKV_PV(angenommenesBruttoVP)
    const anteilKV = berechneBeitragZurKrankenversicherungProJahr(versicherungspflichtigesEinkommenKV_PV)
    const anteilPV = berechneBeitragZurPflegeversicherungProJahr(versicherungspflichtigesEinkommenKV_PV, bundesland, geburtsJahr, anzahlKinder)
    if (gesetzlich_versichert) {
        VSP3 = anteilKV + anteilPV
    } else {
        if (steuerklasse !== 6) {
            // Angegebene Summe für private Versicherung (KV, PV)
            VSP3 = privat_versichert
        }
    }
    return VSP3
}

// UPEVP: Berechnung der Vorsorgepauschale
export function berechnung_vorsorge_pauschale (jahresBrutto, gesetzlich_versichert, bundesland, steuerklasse, geburtsJahr, anzahlKinder, privat_versichert) {
    // Wir nehmen an es gibt immer eine gestetzliche Rentenversicherung, da wir keine eigenen Eingabe Paramater hierfür haben.
    let ZRE4VP = jahresBrutto
    ZRE4VP = berechneVersicherungsPflichtigesEinkommenRV(ZRE4VP, bundesland)
    const VSP1 = ZRE4VP * steuerKonstanten.RVSATZAN

    let VSP2 = 0.12 * ZRE4VP
    const VHB = getVHB(steuerklasse)

    if (VSP2 > VHB) {
        VSP2 = VHB
    }

    const VSPN = Math.ceil(VSP1 + VSP2)
    const VSP3 = vergleichsberechnungMindestVorsorgePauschale(ZRE4VP, gesetzlich_versichert, bundesland, geburtsJahr, anzahlKinder, steuerklasse, privat_versichert)
    // Seite 15
    let VSP = Math.ceil(VSP3 + VSP1)
    let VKV = 0

    if (VSPN > VSP) {
        VSP = VSPN
    }
    // TODO für die Berechnung berücksichtigten Beiträge zur privaten Kranken- und Pflegeversicherung
    if (VSP2 > VSP3) {
        VKV = VSP2 * 100
    } else {
        VKV = VSP3 * 100
    }
    return VSP
}

// MZTABFB Berechnung des Kinderfreibetrags
export function berechnung_kinderfreibetrag (steuerklasse, anzahlKinder) {
    let KINDERFREIBETRAG = 0
    if (steuerklasse < 5) {
        KINDERFREIBETRAG = steuerklasse < 4
            ? anzahlKinder * steuerKonstanten.KINDERFREIBETRAG_123
            // bei Steuerklasse 4 nur halben Kinderfreibetrag
            : anzahlKinder * steuerKonstanten.KINDERFREIBETRAG_123 * 0.5
    }
    return KINDERFREIBETRAG
}

// MZTABFB Berechnung der Tabellenfreibeträge
export function berechnung_tabellen_freibeträge (steuerklasse) {
    let TABELLENFREIBETRAEGE = 0
    if (steuerklasse < 6) {
        TABELLENFREIBETRAEGE =
            steuerKonstanten.ARBEITNEHMER_PAUSCH +
            steuerKonstanten.SONDERAUSGABEN_PAUSCH
        if (steuerklasse === 2) {
            TABELLENFREIBETRAEGE += steuerKonstanten.EFA
        }
    }
    return TABELLENFREIBETRAEGE
}

// Berechnung des zu versteuernden Einkommens pro Jahr
export function berechneZVEInEuro (jahresBrutto, gesetzlich_versichert, steuerklasse, bundesland, anzahlKinder, geburtsjahr, steuerfreibetrag, privat_versichert) {
    let ZVE = 0
    let vSteuerfreibetrag
    if (typeof steuerfreibetrag === "number") {
        vSteuerfreibetrag = steuerfreibetrag
    } else {
        vSteuerfreibetrag = 0
    }
    const vorsorgePauschale = berechnung_vorsorge_pauschale(jahresBrutto, gesetzlich_versichert, bundesland, steuerklasse, geburtsjahr, anzahlKinder, privat_versichert)
    const kinderFreibeträge = berechnung_kinderfreibetrag(steuerklasse, anzahlKinder)
    const tabellen_freibetraege = berechnung_tabellen_freibeträge(steuerklasse)

    const altersenlastungsBetrag = berechneAltersentlastungsBetrag(geburtsjahr, jahresBrutto)

    const summeAllerAbzuege = vorsorgePauschale + kinderFreibeträge + tabellen_freibetraege + altersenlastungsBetrag + vSteuerfreibetrag

    ZVE = jahresBrutto - summeAllerAbzuege

    // In der Lohnsteuerübersicht wird dieser Wert mit X referenziert.
    return ZVE
}

// UPTAB24 Berechnung der tariflichen Einkommensteuer
function berechneLohnsteuerFuerSteuerklasseKleiner5 (X, steuerklasse) {
    const KZTAB = steuerklasse === 3 ? 2 : 1
    let ST = 0
    // Steuerklasse 1 - 4
    if (X <= steuerKonstanten.GFB) {
        ST = 0
    } else if (X <= steuerKonstanten.UNTEREPROGRESSIONSZONE) {
        let y = (X - steuerKonstanten.GFB)
        y = y / 10000
        let RW = 932.30 * y
        RW = RW + 1400
        ST = Math.floor(RW * y)
    } else if (X < steuerKonstanten.OBEREPROGRESSIONSZONE) {
        const y = (X - steuerKonstanten.UNTEREPROGRESSIONSZONE) / 10000
        let RW = y * 176.64
        RW = RW + 2397
        RW = RW * y
        ST = Math.floor(RW + 1015.13)
    } else if (X < steuerKonstanten.OBERGRENZE_PROPORTIONALZONE1) {
        ST = Math.floor(0.42 * X - 10911.92)
    } else {
        ST = Math.floor(0.45 * X - 19246.67)
    }
    ST = ST * KZTAB
    return ST
}

// MST5-6 Steuerberechnung für Steuerklasse 5,6
function berechneLohnsteuerFuerSteuerklasse5und6 (X, steuerklasse) {
    let ST = 0
    const ZZX = X
    let ZX
    if (ZZX > steuerKonstanten.W2STKL5) {
        ZX = steuerKonstanten.W2STKL5
        ST = UP5_6(ZX, steuerklasse)
        if (ZZX > steuerKonstanten.W3STKL5) {
            ST = ST + (steuerKonstanten.W3STKL5 - steuerKonstanten.W2STKL5) * 0.42
            ST = Math.floor(ST + (ZZX - steuerKonstanten.W3STKL5) * 0.45)
        } else {
            ST = Math.floor(ST + (ZZX - steuerKonstanten.W2STKL5) * 0.42)
        }
    } else {
        ZX = ZZX
        ST = UP5_6(ZX, steuerklasse)
        if (ZZX > steuerKonstanten.W1STKL5) {
            const VERGL = ST
            ZX = steuerKonstanten.W1STKL5
            ST = UP5_6(ZX, steuerklasse)
            const HOCH = Math.floor(ST + (ZZX - steuerKonstanten.W1STKL5) * 0.42)
            if (HOCH < VERGL) {
                ST = HOCH
            } else {
                ST = VERGL
            }
        }
    }
    return Math.floor(ST)
}

// S.17 Hilfsfunktion für Steuerberechnung f. Steuerklasse 5,6
function UP5_6 (ZX, steuerklasse) {
    const ST = 0
    const X1 = ZX * 1.25
    const ST1 = berechneLohnsteuerFuerSteuerklasseKleiner5(X1, steuerklasse)
    const X2 = ZX * 0.75
    const ST2 = berechneLohnsteuerFuerSteuerklasseKleiner5(X2, steuerklasse)
    const DIFF = (ST1 - ST2) * 2
    const MIST = ZX * 0.14
    if (MIST > DIFF) {
        return Math.floor(MIST)
    } else {
        return Math.floor(DIFF)
    }
}

// TODO Berechungsjahr einbauen und testen
export function berechneAltersentlastungsBetrag (geburtsjahr, jahresBrutto, berechnungsjahr) {
    const AJAHR = kalenderJahrNachVollendung64Lebensjahr(geburtsjahr)
    berechnungsjahr = berechnungsjahr || new Date().getFullYear()
    const ALTER1 = berechnungsjahr >= AJAHR ? 1 : 0
    let altersenlastungsBetrag = 0
    if (ALTER1 === 1) {
        let K
        if (AJAHR <= 2006) {
            K = 1
        } else if (AJAHR < 2058) {
            K = AJAHR - 2004
        } else {
            K = 54
        }
        const tabelle = steuerKonstanten.ALTERS_ENLASTUNG_PROZENT_MAX.find((element) => {
            return element.K === K
        })
        if (tabelle) {
            const prozentualerAltersentlastungsbetrag = jahresBrutto * tabelle.satz
            const maximalerAltersentlastungsbetrag = tabelle.max
            if (prozentualerAltersentlastungsbetrag > maximalerAltersentlastungsbetrag) {
                altersenlastungsBetrag = maximalerAltersentlastungsbetrag
            } else {
                altersenlastungsBetrag = prozentualerAltersentlastungsbetrag
            }
        }
    }
    return altersenlastungsBetrag
}

// Berechnung der Lohnsteuer nach Steuerklasse (UPMLST)
// ZVE: zu versteuerndes Jahreseinkommen in Euro
export function berechneJahresLohnsteuer (ZVE, steuerklasse) {
    let ST = 0
    let X = 0
    // KZTAB = Kennzahl für die Einkommensteuer-Tarifarten:
    // 1 = Grundtarif
    // 2 = Splittingverfahren
    const KZTAB = steuerklasse === 3 ? 2 : 1

    // S.13 Ermittlung der Jahreslohnsteuer
    if (ZVE < 1) {
        X = 0
    } else {
        X = Math.floor(ZVE / KZTAB)
    }

    if (steuerklasse < 5) {
        // Steuerklass 1-4
        // S. 20
        ST = berechneLohnsteuerFuerSteuerklasseKleiner5(X, steuerklasse)
        // eslint-disable-next-line brace-style
    }
    // Steuerklasse 5,6
    // S.16
    else {
        ST = berechneLohnsteuerFuerSteuerklasse5und6(X, steuerklasse)
    }
    return ST
}

export function berechneBeitragZurKrankenversicherungProJahr (versicherungspflichtigesEinkommen) {
    const KVSATZAN = getKVSatzAn()
    const KVAnteilInCent = Math.round(versicherungspflichtigesEinkommen * KVSATZAN * 100)
    return KVAnteilInCent / 100
}

export function berechneBeitragZurPflegeversicherungProJahr (versicherungspflichtigesEinkommen, bundesland, geburtsJahr, anzahlKinder) {
    const PVSATZAN = getPVSatzAn(bundesland, geburtsJahr, anzahlKinder)
    const PVAnteilInCent = Math.round(versicherungspflichtigesEinkommen * PVSATZAN * 100)
    return PVAnteilInCent / 100
}

export function berechneBeitragZurRentenversicherungProJahr (versicherungspflichtigesEinkommen) {
    const RVAnteilInCent = Math.round(versicherungspflichtigesEinkommen * steuerKonstanten.RVSATZAN * 100)
    return RVAnteilInCent / 100
}

export function berechneBeitragZurArbeitslosenVersicherungProJahr (versicherungspflichtigesEinkommen) {
    const arbeitslosenVersicherungInCent = Math.round(versicherungspflichtigesEinkommen * steuerKonstanten.AV_SATZ * 100)
    return arbeitslosenVersicherungInCent / 100
}

export function berechneLohnsteuerProJahr (jahresBrutto, gesetzlich_versichert, steuerklasse, bundesland, anzahlKinder, geburtsjahr, steuerfreibetrag, privat_versichert) {
    const ZVE = berechneZVEInEuro(jahresBrutto, gesetzlich_versichert, steuerklasse, bundesland, anzahlKinder, geburtsjahr, steuerfreibetrag, privat_versichert)
    return berechneJahresLohnsteuer(ZVE, steuerklasse)
}

export function berechneSolidaritaetszuschlagProJahr (jahresLohnsteuer, steuerklasse, kirchensteuer) {
    const KZTAB = steuerklasse === 3 ? 2 : 1
    const SOLIZFREI = KZTAB * steuerKonstanten.SOLIZFREI
    if (jahresLohnsteuer > SOLIZFREI) {
        let SOLZJ = jahresLohnsteuer * 5.5 / 100
        const SOLZMIN = (jahresLohnsteuer - SOLIZFREI) * 11.9 / 100
        if (SOLZMIN < SOLZJ) {
            SOLZJ = SOLZMIN
        }
        const inCent = Math.floor(SOLZJ * 100)
        return inCent / 100
    } else {
        return 0
    }
}

export function berechneKirchensteuerProJahr (jahresLohnsteuer, bundesland) {
    // Kappung nicht mit einberechnet
    const kirchensteuerProJahr = jahresLohnsteuer * steuerKonstanten.KIRCHENSTEUER_TABELLE[bundesland]
    const kirchensteuerInCent = Math.round(kirchensteuerProJahr * 100)
    return kirchensteuerInCent / 100
}

export function istPerson23oderAelter (geburtsjahr) {
    const dateNow = new Date().getFullYear()
    return dateNow - geburtsjahr >= 23
}

export function kalenderJahrNachVollendung64Lebensjahr (geburtsjahr) {
    return geburtsjahr + 65
}

/**
 * Berechnet das Jahres-Netto unter Berücksichtigung von Steuern, SV und bAV-Sparen.
 * @param {number} jahresBrutto - Das Gesamtbrutto (inkl. Sonderzahlungen)
 * @param {boolean} gesetzlich_versichert - Status KV
 * ... (weitere Parameter)
 * @param {number} bav_betrag - Betrag, der vom Brutto gespart wird (Entgeltumwandlung)
 */
export function berechneNettoLohnProJahr(
    jahresBrutto,
    gesetzlich_versichert,
    steuerklasse,
    bundesland,
    kinder,
    geburt_jahr,
    steuerfreibetrag,
    kirchensteuer,
    privat_versichert,
    bav_betrag = 0 // Standardmäßig 0
) {
    // 1. Steuerpflichtiges Brutto (bAV reduziert das zu versteuernde Einkommen)
    const steuerBrutto = Math.max(0, jahresBrutto - bav_betrag);

    const jahresLohnsteuer = berechneLohnsteuerProJahr(
        steuerBrutto,
        gesetzlich_versichert,
        steuerklasse,
        bundesland,
        kinder,
        geburt_jahr,
        steuerfreibetrag,
        privat_versichert
    );

    // 2. Sozialversicherungspflichtiges Einkommen berechnen
    // (Diese Funktionen müssen den bav_betrag als Abzug von der BBG berücksichtigen)
    const vEinkommenRV = berechneVersicherungsPflichtigesEinkommenRV(jahresBrutto, bundesland, bav_betrag);
    const vEinkommenKV_PV = berechneVersicherungsPflichtigesEinkommenKV_PV(jahresBrutto, bav_betrag);

    // 3. Abzüge berechnen
    const solidaritaetszuschlag = berechneSolidaritaetszuschlagProJahr(jahresLohnsteuer, steuerklasse, kirchensteuer);
    
    let kirchensteuerBetrag = 0;
    if (kirchensteuer) {
        kirchensteuerBetrag = berechneKirchensteuerProJahr(jahresLohnsteuer, bundesland);
    }

    const rentenversicherungProJahr = berechneBeitragZurRentenversicherungProJahr(vEinkommenRV, bundesland);
    const krankenversicherungProJahr = berechneBeitragZurKrankenversicherungProJahr(vEinkommenKV_PV);
    const pflegeversicherungProJahr = berechneBeitragZurPflegeversicherungProJahr(vEinkommenKV_PV, bundesland, geburt_jahr, kinder);
    const arbeitslosenVersicherungProJahr = berechneBeitragZurArbeitslosenVersicherungProJahr(vEinkommenRV, bundesland);

    // 4. Jahres-Netto (Vom steuerBrutto minus alle Abzüge)
    const netto_jahr = Math.round(
        (steuerBrutto -
            jahresLohnsteuer -
            solidaritaetszuschlag -
            kirchensteuerBetrag -
            rentenversicherungProJahr -
            krankenversicherungProJahr -
            pflegeversicherungProJahr -
            arbeitslosenVersicherungProJahr) * 100) / 100;

    // Optionaler Debug-Log für Staging
    if (typeof window !== "undefined" && window.location.hostname.includes("staging")) {
        console.log("--- Netto Berechnung 2026 ---", { 
            jahresBrutto, steuerBrutto, bav_betrag, netto_jahr 
        });
    }

    return netto_jahr;
}
